import { DesktopMode, MobileMode } from 'layout'
import React from 'react'
import { Header } from 'semantic-ui-react'

export const PageHeader = ({ header, hideWeb = false }) => {
    return (
        <>
            {!hideWeb && <DesktopMode>
                <Header>{header}</Header>
            </DesktopMode>}
            <MobileMode>
                <h3>{header}</h3>
            </MobileMode>
        </>
    )
}